import React from 'react';
import {makeStyles, Typography, useTheme} from "@material-ui/core";
import {BP_LARGE, BP_MEDIUM} from "Theme/breakpoints";
import {RewardslevelBar} from "../Components/RewardsLevelBar";
import {REWARDS_SCHEME_NAME} from "Setup/config";

export const useRewardsHeaderStyles = makeStyles(theme => {
    const RewardsPageSettings = theme.overrides.RewardsPage;
    return {
        root: {
            background: RewardsPageSettings.headerBackground,
            borderTopLeftRadius: RewardsPageSettings.borderRadius,
            borderTopRightRadius: RewardsPageSettings.borderRadius,
            color: RewardsPageSettings.headerTextColor,
            paddingTop: '1rem',
            textAlign: 'center',
            [theme.breakpoints.up(BP_LARGE)]: {
                height: 400,
                paddingTop: '3rem',
                textAlign: 'left'
            },
            '& .align-center': {
                margin: '0 auto'
            },
            '& .level': {
                textAlign: 'center',
                '& img': {
                    maxHeight: 140,
                    [theme.breakpoints.up(BP_MEDIUM)]: {
                        maxHeight: 190,
                    },
                    [theme.breakpoints.up(BP_LARGE)]: {
                        maxHeight: 259,
                    },
                },
                '& span': {
                    display: 'block',
                    fontSize: '1.5rem',
                    marginBottom: '1rem',
                }
            },
            '& .MuiTypography-h1': {
                fontSize: '1rem',
                padding: '1rem 0',
                fontWeight: 'bold',
                [theme.breakpoints.up(BP_LARGE)]: {
                    fontSize: '2.25rem',
                    textAlign: 'left',
                    marginBottom: '1rem',
                    paddingTop: '3.8rem'
                }
            },
            '& .MuiTypography-body2': {
                padding: '0.75rem 0',
                [theme.breakpoints.up(BP_LARGE)]: {
                    paddingTop: '4rem',
                }
            }

        },
        rewardsLogo: {
            width: 108,
            display: 'block',
            margin: '2px auto'
        }
    }
});

export const RewardsHeader = (props) => {
    const classes = useRewardsHeaderStyles();
    const currentLevel = props.currentLevel;
    const theme = useTheme();
    const imagesPath = `${theme.layout.brandPath}rewards`;
    const currentLevelImage = `${imagesPath}/level-${currentLevel}.png`;
    const {showBadgeLogo} = theme.overrides.RewardsPage;

    return (
        <div className={classes.root}>
            <div className={`row small-11 medium-11 align-center`}>
                <div className={`small-10 large-3 level`}>
                    {showBadgeLogo && <img className={classes.rewardsLogo} src={`${imagesPath}/logo-rewards.png`} alt="rewards"/>}
                    <img src={currentLevelImage} alt="Current Level"/>
                </div>
                <div className={`small-10 large-8`}>
                    <Typography variant="h1" component="h1">{REWARDS_SCHEME_NAME}</Typography>
                    <RewardslevelBar currentLevel={currentLevel} currentPoints={props.currentPoints}/>
                    <Typography gutterBottom variant="body2">
                        Tip: Deposit or play and keep earning points. Rewards points are calculated once a day.
                    </Typography>
                </div>
            </div>
        </div>
    );
}
